import { render, staticRenderFns } from "./AgencyProfileFeedSection.vue?vue&type=template&id=1ba679f8&scoped=true"
import script from "./AgencyProfileFeedSection.vue?vue&type=script&lang=js"
export * from "./AgencyProfileFeedSection.vue?vue&type=script&lang=js"
import style0 from "./AgencyProfileFeedSection.vue?vue&type=style&index=0&id=1ba679f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba679f8",
  null
  
)

export default component.exports